import { createPathFromRoute } from 'assets/utils/dom/UrlParsing';
import executeServerApi from 'assets/utils/server/ServerApi';
import { getDefaultHeaders, HttpMethod } from 'config/Api.Config';

type Request = Api.Core.PricingDistributionTemplate.Delete.IRequest;
type Response = Api.Core.PricingDistributionTemplate.Delete.IResponse;
type Headers = Api.Core.PricingDistributionTemplate.Delete.IHeaders;
const url = '/api/ProductManagement/PricingDistributionTemplate/:id';
export default async function pricingDistributionTemplateDeleteApi(id: number): Promise<Api.Res<Response>> {
  const serverResponse = await executeServerApi<Request, Response, Headers>({
    method: HttpMethod.delete,
    url: createPathFromRoute(url, { id }),
    headers: getDefaultHeaders(),
  });
  return serverResponse;
}
